module.exports = __webpack_public_path__ + "static/media/298302.13cd1ce3.png";